module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormList) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFormList = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Processar Lote " + _vm._s(_vm.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFormList = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "processar-actions"
  }, [_c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--primary",
    on: {
      "click": function($event) {
        return _vm.onRegister(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Processar Lote\n            ")])]), _vm._v(" "), _c('esocial-tabela', {
    attrs: {
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingContent,
      "pagination": _vm.pagination,
      "onSearch": _vm.getEsocialLotesProcessar,
      "disableCheckAll": true
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModo) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showModo = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Selecione o modo de transmissão do arquivo")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showModo = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "modo-info"
  }, [_c('div', {
    staticClass: "modo-info__row"
  }, [_c('b', [_vm._v("Inclusão")]), _vm._v(" "), _c('span', [_vm._v("Selecione esta opção na primeira vez que enviar o lote ou quando a tentativa de inclusão foi rejeitada.")])]), _vm._v(" "), _c('div', {
    staticClass: "modo-info__row"
  }, [_c('b', [_vm._v("Alteração")]), _vm._v(" "), _c('span', [_vm._v("Selecione esta opção para alterar o evento. Nesse ponto deve existir um lote de inclusão enviado.")])])]), _vm._v(" "), (_vm.tableData && _vm.tableData.length > 0) ? _c('div', {
    staticClass: "modo-ultimo",
    class: {
      'modo-ultimo--erro': _vm.tableData[0]._data.status != '201'
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.tableData[0]._data.status == '201' ? 'fa-check-circle' : 'fa-exclamation-triangle'
  }), _vm._v(" "), _c('div', [_c('b', [_vm._v("Último lote enviado:")]), _vm._v("\n              " + _vm._s(_vm.parseModo(_vm.tableData[0]._data.modo)) + " em " + _vm._s(_vm.toDate(_vm.tableData[0]._data.created_at, false)) + "\n              "), (_vm.tableData[0]._data.status != '201') ? _c('div', {
    staticClass: "modo-ultimo__aviso"
  }, [_vm._v("\n                Lote não processado. Verifique o detalhamento do processamento.\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modo-options"
  }, [_c('button', {
    staticClass: "modo-option modo-option--inclusao",
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'inc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "modo-option__title"
  }, [_vm._v("Inclusão")]), _vm._v(" "), _c('span', {
    staticClass: "modo-option__desc"
  }, [_vm._v("Primeiro envio do lote, ou reenvio após rejeição.")])]), _vm._v(" "), (_vm.formData && _vm.formData.layout != 'S-3000') ? _c('button', {
    staticClass: "modo-option modo-option--alteracao",
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'alt')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('span', {
    staticClass: "modo-option__title"
  }, [_vm._v("Alteração")]), _vm._v(" "), _c('span', {
    staticClass: "modo-option__desc"
  }, [_vm._v("Altera um evento já incluído anteriormente.")])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showLogs) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showLogs = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("\n            Status processamento " + _vm._s(_vm.formDataLogs.protocolo ? _vm.formDataLogs.protocolo : "") + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showLogs = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "processar-log"
  }, [_vm._l((_vm.formDataLogs.log_retorno), function(retorno, i) {
    return _c('div', {
      key: i,
      staticClass: "processar-log__item",
      class: retorno.ocorrencias && retorno.ocorrencias.length ?
        'processar-log__item--error' :
        'processar-log__item--success'
    }, [_c('div', {
      staticClass: "processar-log__status",
      class: {
        'processar-log__status--error': retorno.ocorrencias && retorno.ocorrencias.length
      }
    }, [_c('i', {
      staticClass: "fa",
      class: retorno.ocorrencias && retorno.ocorrencias.length ? 'fa-exclamation-triangle' : 'fa-check-circle'
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(retorno.cdResposta))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(retorno.descResposta))])]), _vm._v(" "), (retorno.uid) ? _c('div', {
      staticClass: "processar-log__arquivo"
    }, [_c('div', {
      staticClass: "processar-log__arquivo-row"
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(retorno.uid))])]), _vm._v(" "), (retorno.recibo) ? _c('div', {
      staticClass: "processar-log__arquivo-recibo"
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Recibo: " + _vm._s(retorno.recibo) + "\n                ")]) : _vm._e(), _vm._v(" "), (retorno.funcionario) ? _c('div', {
      staticClass: "processar-log__arquivo-funcionario"
    }, [_vm._v("\n                  " + _vm._s(retorno.funcionario) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (retorno.ocorrencias && retorno.ocorrencias.length) ? _c('div', {
      staticClass: "processar-log__ocorrencias"
    }, _vm._l((retorno.ocorrencias), function(ocorrencia, j) {
      return _c('div', {
        key: j,
        staticClass: "processar-log__ocorrencia"
      }, [_c('b', [_vm._v(_vm._s(ocorrencia.codigo))]), _vm._v(" " + _vm._s(ocorrencia.descricao) + "\n                  "), (ocorrencia.localizacao) ? _c('span', {
        staticClass: "processar-log__ocorrencia-loc"
      }, [_vm._v("\n                    em " + _vm._s(ocorrencia.localizacao) + "\n                  ")]) : _vm._e()])
    }), 0) : _vm._e()])
  }), _vm._v(" "), (!_vm.formDataLogs.log_retorno || !_vm.formDataLogs.log_retorno.length) ? _c('div', {
    staticClass: "processar-log__empty"
  }, [_vm._v("\n              Nenhum detalhe de envio disponível.\n            ")]) : _vm._e()], 2)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showLogsReq) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showLogsReq = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v(_vm._s(_vm.titleLogsReq) + " Lote " + _vm._s(_vm.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showLogsReq = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('pre', {
    staticClass: "xml-viewer"
  }, [_vm._v(_vm._s(_vm.formatXml(_vm.messageLogsReq)))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60106157"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/processar/index.vue
// module id = 1529
// module chunks = 45